export default __webpack_public_path__ + "static/media/icon-coin-cfg.148ea0c4.svg";